import { Badge, Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import moment from "moment";
import { usStateOptions } from "../../../utils/case/usStateOption";

const ViewInfo = ({ info }) => {
  const getFullStateName = (abbreviation) => {
    const match = usStateOptions.find((state) => state.value === abbreviation);
    return match ? match.label : abbreviation;
  };

  return (
    <Box minH="50vh">
      <SimpleGrid columns={3} spacing={2}>
        {info.key === "RACE" ? (
          <Box
            p={4}
            bg="gray.100"
            boxShadow="md"
            borderRadius="md"
            textAlign="left"
            mt={4}
            color="red"
          >
            {info?.data}
          </Box>
        ) : (
          info?.data?.map((item, idx) => {
            return (
              <Box
                key={idx}
                p={4}
                bg="gray.100"
                boxShadow="md"
                borderRadius="md"
                textAlign="left"
                mt={4}
              >
                {Object.entries(item)
                  .filter(([key]) => key !== "id")
                  .map(([key, value]) => {
                    let displayValue = value;

                    // Format valid date strings
                    if (moment(value, moment.ISO_8601, true).isValid()) {
                      displayValue = moment(value).format("MMM D, YYYY");
                    }

                    // Replace state abbreviation with full name
                    if (key.toUpperCase() === "STATE") {
                      displayValue = getFullStateName(value);
                    }

                    return (
                      <Flex
                        key={key}
                        // alignItems="center"
                        justifyContent="space-evenly"
                        fontSize="sm"
                        pt={2}
                      >
                        <Box textAlign="left" w="20%">
                          {key.replace(/_/g, " ")}
                        </Box>
                        <Box textAlign="center"> : </Box>
                        <Box textAlign="left" width="60%" ml={1}>
                          {Array.isArray(displayValue) ? (
                            displayValue.length > 0 ? (
                              <Flex wrap="wrap" gap={1}>
                                {displayValue.map((val, i) => (
                                  <Badge
                                    key={idx}
                                    colorScheme="cyan"
                                    p={1}
                                    borderRadius="md"
                                    color="black"
                                    fontWeight="normal"
                                  >
                                    {val}
                                  </Badge>
                                ))}
                              </Flex>
                            ) : (
                              <Text>N/A</Text>
                            )
                          ) : (
                            <Text>{displayValue || "N/A"}</Text>
                          )}
                        </Box>
                      </Flex>
                    );
                  })}
              </Box>
            );
          })
        )}
      </SimpleGrid>
    </Box>
  );
};

export default ViewInfo;
